// chainlink.js.liquid

function setAnnouncementBarHeight() {
  const bar = document.querySelector('.announcement-bar');
  const height = bar ? bar.getBoundingClientRect().height : 0;
  document.documentElement.style.setProperty('--top-bar', height + 'px');
}

setAnnouncementBarHeight();
window.addEventListener('resize', setAnnouncementBarHeight);

$('body:has(.festoni-section-paragraph) .shopify-section-group-footer-group img')
  .attr('src', 'https://cdn.shopify.com/s/files/1/0735/5809/8150/files/light-icon.svg?v=1776936468')
  .attr('srcset', '');

$('body:has(.festoni-section-paragraph) #MenuDrawer .drawer__header img')
  .attr('src', '//festoni.com/cdn/shop/files/festoni-white_4b3d51b3-4470-4c4d-9aa9-e90a508c4f8f.svg?v=1751280662&width=160')
  .attr('srcset', '//festoni.com/cdn/shop/files/festoni-white_4b3d51b3-4470-4c4d-9aa9-e90a508c4f8f.svg?v=1751280662&width=160 1x, //festoni.com/cdn/shop/files/festoni-white_4b3d51b3-4470-4c4d-9aa9-e90a508c4f8f.svg?v=1751280662&width=320 2x');